import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchMe } from "../utils/dashboardAuth";

const Ctx = createContext({ role: null, me: null, loading: true, refresh: () => {} });

export function DashboardRoleProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = () => {
    setLoading(true);
    return fetchMe()
      .then((data) => {
        setMe(data);
        return data;
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    refresh();
  }, []);
  return (
    <Ctx.Provider value={{ role: me && me.role, me, loading, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export function useDashboardRole() {
  return useContext(Ctx);
}
